<template>
    <div style="margin-right: 10px;">
        <date-picker :lang="lang" :disabled-date="(date) => date <= min" :confirm="true" v-model="time" :type="pickerType" :shortcuts="shortcuts" :show-time-header="timeHeader" :disabled="isDisabled"></date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: {
        dateFrom: {
            required: false,
            default: null
        },
        timeHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
        pickerType: {
            type: String,
            required: false,
            default: "datetime"
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        },
        min: {
            type: Date,
            required: false,
            default: null
        }
    },
    computed: {
        from() {
            return new Date(this.dateFrom)
        },
    },
    components: {
        DatePicker
    },
    data() {
        let now = new Date();
        now = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let yesterday = new Date()
        let weekAgo = new Date()
        let tenDaysAgo = new Date()
        let thisMonth = new Date()
        let lastMonthFrom = new Date()
        let lastMonthTo = new Date()
        let last3MonthsFrom = new Date()
        weekAgo.setDate(now.getDate() - 7)
        weekAgo = new Date(weekAgo.getFullYear(), weekAgo.getMonth(), weekAgo.getDate(), 0, 0, 0)
        yesterday.setDate(now.getDate() - 1)
        yesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0)
        tenDaysAgo.setDate(now.getDate() - 10)
        tenDaysAgo = new Date(tenDaysAgo.getFullYear(), tenDaysAgo.getMonth(), tenDaysAgo.getDate(), 0, 0, 0)
        thisMonth.setDate(now.getDate())
        thisMonth = new Date(thisMonth.getFullYear(), thisMonth.getMonth(), 1, 0, 0, 0)
        lastMonthFrom.setDate(now.getDate())
        lastMonthFrom.setMonth(now.getMonth() - 1)
        lastMonthFrom = new Date(lastMonthFrom.getFullYear(), lastMonthFrom.getMonth(), 1, 0, 0, 0)
        lastMonthTo = new Date(lastMonthFrom.getFullYear(), lastMonthFrom.getMonth() + 1, 0, 23, 59, 59)
        last3MonthsFrom.setMonth(now.getMonth() - 3)
        last3MonthsFrom.setHours(0, 0, 0)

        return {
            time: [],
            shortcuts: [
                { 
                    text: this.$t('Today'), 
                    onClick: () => { 
                        this.time = [
                            today, 
                            now
                        ] 
                    }
                },
                {
                    text: this.$t('Yesterday'),
                    onClick: () => {
                        this.time = [
                            yesterday, 
                            new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59)
                        ] 
                    },
                },
                {
                    text: this.$t('Last7days'),
                    onClick: () => {
                        this.time = [
                            weekAgo,
                            now
                        ] 
                    },
                },
                {
                    text: this.$t('Last10days'),
                    onClick: () => {
                        this.time = [
                            tenDaysAgo,
                            now
                        ]
                    }
                },
                {
                    text: this.$t('ThisMonth'),
                    onClick: () => {
                        this.time = [
                            thisMonth,
                            now
                        ]
                    }
                },
                {
                    text: this.$t('LastMonth'),
                    onClick: () => {
                        this.time = [
                            lastMonthFrom,
                            lastMonthTo
                        ]
                    }
                },
                {
                    text: this.$t('Last3Months'),
                    onClick: () => {
                        this.time = [
                            last3MonthsFrom,
                            now
                        ]
                    }
                }
            ],
            lang: {
                formatLocale: {
                    // MMMM
                    months: [this.$t('January'), this.$t('February'), this.$t('March'), this.$t('April'), this.$t('May'), this.$t('June'), this.$t('July'), this.$t('August'), this.$t('September'), this.$t('October'), this.$t('November'), this.$t('December')],
                    // MMM
                    monthsShort: [this.$t('Jan'), this.$t('Feb'), this.$t('Mar'), this.$t('Apr'), this.$t('MayShort'), this.$t('Jun'), this.$t('Jul'), this.$t('Aug'), this.$t('Sep'),this.$t( 'Oct'), this.$t('Nov'), this.$t('Dec')],
                    // dddd
                    weekdays: [ this.$t('Sunday'),this.$t('Monday'), this.$t('Tuesday'), this.$t('Wednesday'), this.$t('Thursday'), this.$t('Friday'), this.$t('Saturday')],
                    // ddd
                    weekdaysShort: [ this.$t('Sun'),this.$t('Mon'), this.$t('Tue'), this.$t('Wed'), this.$t('Thu'), this.$t('Fri'), this.$t('Sat')],
                    // dd
                    weekdaysMin: [this.$t('Su'),this.$t('Mo'), this.$t('Tu'), this.$t('We'), this.$t('Th'), this.$t('Fr'), this.$t('Sa') ],
                    // first day of week
                    firstDayOfWeek: 1,
                    // first week contains January 1st.
                    firstWeekContainsDate: 1,
                },
                monthBeforeYear: false, //us time? 
            },
        };
    },
    watch: {
        time(newVal, oldVal) {
            // console.log(newVal, oldVal)
            if(newVal == null){
                this.$emit('dateChanged', null)
                return;
            }

            this.$emit('dateChanged', newVal.toISOString());

            if(newVal != oldVal){
                this.$emit('fromChanged', newVal.toISOString())
            }
        }
    },
    methods: {
        setDate() {
            if(this.from != null && this.to != null) {
                this.time = this.from
            }
        },
    },
    mounted: async function() {
        this.setDate()
    }
}
</script>

<style>
.mx-datepicker-sidebar {
    width: 150px;

}

.mx-datepicker-sidebar+.mx-datepicker-content {
        margin-left: 150px;
}
</style>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/V2Datepicker.vue